export default __webpack_public_path__ + "static/media/Vector-3.33cd2841.svg";